import { render } from "./Card.vue?vue&type=template&id=1ccd016a"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"

import "./Card.vue?vue&type=style&index=0&id=1ccd016a&lang=stylus"
script.render = render

export default script